export default {"src":"/_next/static/image/public/images/icons4/4.cef66fab696151bc50020a414bb25857.svg","height":43,"width":44};